import type { WorkOrder } from '@/domain/work-order.types'
import type { ResolvedWorkflowSnapshot } from '@/domain/workflow.types'
import { useWorkOrderWorkflowSnapshot } from '@/hooks/useWorkOrders'

/**
 * The single entry point every consumer reads the workflow-snapshot through —
 * a `useQuery` selector over `GET /work-orders/{id}`'s `workflowSnapshot`
 * field (`undefined` while loading or with no order yet, `null` once loaded
 * if the order has no usable workflow, matching `useWorkOrderWorkflow`'s own
 * null contract). Each status's resolved workspace now travels INSIDE the
 * snapshot (`statuses[].workspace`, design.md D5) — a caller that needs one
 * looks it up there by status code, rather than through a separate field.
 */
export function useResolvedWorkflow(workOrder: WorkOrder | undefined): {
	snapshot: ResolvedWorkflowSnapshot | null | undefined
} {
	const { data: snapshot } = useWorkOrderWorkflowSnapshot(workOrder?.workOrderId ?? null)
	return { snapshot }
}
